import router from '@/router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import TokenCache from '@/utils/cache/TokenCache'
import OperatorCache from '@/utils/cache/OperatorCache'
import defaultSettings from '@/config/defaultSettings'
import store from '@/store'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = [
  'Index',
  'XunJianGo',
  'XunJianGoIOS',
  'NoT',
  'TemplateLogin',
  'TemplateIndex',
  'TemplateHome',
  'TemplateForm',
  'TemplateUser',
  'UserSign',
  // 'TemplateHomeForm',
] // no redirect whitelist

router.beforeEach((to, from, next) => {
  console.log(to, from, next)
  NProgress.start() // start progress bar
  //获取用户登录成功后储存的登录标志
  // 已授权
  if (TokenCache.getToken()) {
    //设置vuex登录状态为已登录
    OperatorCache.init(() => {
      if (OperatorCache.info.Id === undefined) {
        // TokenCache.deleteToken()
        store.state.isLogin = true
      } else {
        store.state.isLogin = true
      }
      if (to.path === '/') {
        next({ path: '/Home/Index' })
        NProgress.done()
      } else {
        const redirect = decodeURIComponent(from.query.redirect || to.path)
        // 桌面特殊处理
        if (to.path === defaultSettings.desktopPath || to.path === '/404') {
          next()
        } else {
          if (to.path === redirect) {
            next()
          } else {
            // 跳转到目的路由
            next({ path: redirect })
          }
        }
      }
    })
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/Home/Index' })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  window.scroll(0, 0)
  NProgress.done() // finish progress bar
})
